import {RestResource} from '../../rest'
import {ASSESSMENT_SERVER,COMMON_SERVER,PUE_SERVER} from '../../server'
import {athubAxios} from '../../../util'
import axios from 'axios';
import ReliableApi from "@/api/reliable";

//查询监察相关信息
function queryLooksInfo(month){
    return new Promise((resolve, reject) => {
        axios.post(`${ASSESSMENT_SERVER}/assessment/list`, {
                 "month": month + "-01",
                 "validation": "VALID",
                 "status":"CLOSE"
        }
        //     ,{
        //     headers:{
        //     "orgId": localStorage.getItem("authorg"),
        //     "sites": localStorage.getItem("authsites")}
        // }
        ).then((responseBody) => {
            if (responseBody.status == 200) {
            resolve(responseBody.data.data.sort(function(a,b){
                return b.totalscore - a.totalscore;
            }));
            }
        }).catch(error => {
                reject(error);
        });
        });
}




//获取有权限的园区（部门）数据
function queryPrimissionDepts(){
    return new Promise((resolve, reject) => {
            axios.post(COMMON_SERVER+'/dept/getRunningDeptListByAuthSites?orgid='+localStorage.getItem("authorg"), {
            }
        ).then((responseBody) => {
            if (responseBody.status == 200) {
                return resolve(responseBody.data.data);
            }
    }).catch(error => {
            reject(error);
    });
    });
    }


//获取安全指数排名
function queryFsi(deptids,searchStartDate,searchEndDate){
    let params = {
        deptids: deptids,
        searchstartdate: searchStartDate,
        searchenddate: searchEndDate,
    }
    return ReliableApi.queryHisReliableValue(params).then(res => {
        var infoArr=[];
        for(var a=0;a<res.deptids.length;a++){
            var info={};
            info.id=res.deptids[a];
            info.total=res.avgHisReliableValue[a];
            infoArr.push(info);
        }
        return infoArr;    //历史部门安全指数
    });
}

//根据部门查询对应的数据中心
function queryDcnumByDepts(array){

    return new Promise((resolve, reject) => {
            axios.get(`${COMMON_SERVER}/sys/room/getRoomsByDepts?deptIds=`+array, {
            'deptIds':array
        }).then((responseBody) => {
            if (responseBody.status == 200) {
        resolve(responseBody.data.data);
    }
}).catch(error => {
        reject(error);
});
});
}



//根据数据中心开始结束时间查询对应的PUE记录
function queryPueBySysRooms(array,searchStartDate,searchEndDate){
    var userAuthInfo = {
        "token": localStorage.getItem("token"),
        "appId": localStorage.getItem("appId"),
        "authorg": localStorage.getItem("authorg"),
        "authsites": localStorage.getItem("authsites"),
        "defsite": localStorage.getItem("defsite"),
        "realname": "billing-219-oam",
        "userId": localStorage.getItem("userid"),
        "userName": localStorage.getItem("username"),
        "authScope": {
            "userId": localStorage.getItem("userid"),
            "sites": localStorage.getItem("authsites"),
            "orgs": localStorage.getItem("authorg")
        },
        "authorizes": ["billing.ui.RBSC.WO.RSC", "billing.be.RBSC.WO.new", "billing.be.RBSC.WO.RSC", "billing.ui.RBSC.WO.save", "billing.ui.RBSC.WO.view", "billing.ui.RBSC.WO.commit", "billing.ui.RBSC.WO.new", "menu.billing3", "billing.be.RBSC.WO.viewAll", "billing.ui.RBSC.viewAllCustomer", "billing.be.RBSC.viewAllCustomer"]
    };
    var userAuthInfoString = JSON.stringify( userAuthInfo );
    var userAuthInfoStringURIencoded = encodeURIComponent( userAuthInfoString );
    return new Promise((resolve, reject) => {
            axios.post(`${PUE_SERVER}/PUE/daily/list`, {
            'in_roomId':array,
            'eq_recordSource': 0,
            'gt_tsdate':searchStartDate,
            'lt_tsdate':searchEndDate,
        }
        ,{
            headers:{
                'User-Auth-Info':userAuthInfoStringURIencoded}
        }
        ).then((responseBody) => {
            if (responseBody.status == 200) {
            resolve(responseBody.data.data);
        }
    }).catch(error => {
            reject(error);
    });
});
}


export {
    queryLooksInfo,
    queryPrimissionDepts,
    queryFsi,
    queryDcnumByDepts,
    queryPueBySysRooms
}